<template>
  <div>
    <a-card class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item label="名称/ID">
              <a-input v-model="filterForm.name" placeholder="任务名称/ID" class="form-model-item" allow-clear @change="handleChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="状态">
              <a-select v-model="filterForm.status" mode="multiple" placeholder="任务状态" allow-clear @change="handleChange">
                <a-select-option v-for="(item, index) in taskStatus" :key="index" :value="item.value">
                  <a-badge :status="item.status" :color="item.color" :text="item.label" />
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="处理人">
              <user-select v-model="filterForm.handlers" mode="multiple" allow-clear show-search show-all placeholder="任务处理人" :project-id="projectId" @change="handleChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="所属项目">
              <a-select v-model="filterForm.projectList" mode="multiple" show-search placeholder="任务所属项目" allow-clear @focus="getVersionData" @change="handleChange">
                <a-select-option v-for="version in versionData" :key="version.project_id" :value="version.project_id"> {{ version.name }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item label="关联需求">
              <a-select v-model="requirementValue" mode="multiple" show-search allow-clear label-in-value :filter-option="false" :not-found-content="storySearching ? undefined : null" @search="searchStory" @change="handleStoryChange">
                <a-spin v-if="storySearching" slot="notFoundContent" size="small" />
                <a-select-option v-for="item in searchStoryData" :key="item.value" :value="item.value" :version="item.version">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="创建人">
              <user-select v-model="filterForm.creator" allow-clear show-search show-all placeholder="任务创建人" :project-id="projectId" @change="handleChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="标签">
              <a-select v-model="filterForm.tagData" mode="multiple" allow-clear show-search placeholder="标签" :filter-option="utils.filterOption" @change="handleChange">
                <a-select-option v-for="(tag, index) in tagData" :key="index" :value="tag.id">{{ tag.name }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="任务类型">
              <a-tree-select v-model="filterForm.objective" show-search tree-default-expand-all multiple :filter-tree-node="filterModule" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" style="width: 100%" :tree-data="objectiveData" @change="handleChange" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="与我相关">
              <a-radio-group v-model="filterForm.about" button-style="solid" @change="getTaskList">
                <a-radio-button value="all"> 全部 </a-radio-button>
                <a-radio-button value="about"> 与我相关 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item v-show="expand" :label-col="{ span: 3 }" label="时间筛选">
              <a-input-group compact>
                <a-select v-model="filterForm.time_filter_key" style="width: 30%" @change="handleChange">
                  <a-select-option value="pre_time"> 计划时间 </a-select-option>
                  <a-select-option value="real_time"> 实际时间 </a-select-option>
                  <a-select-option value="created_time"> 创建时间 </a-select-option>
                  <a-select-option value="completed_time"> 完成时间 </a-select-option>
                </a-select>
                <a-date-picker v-model="filterForm.start_time" style="width: 35%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="handleChange" />
                <a-date-picker v-model="filterForm.end_time" style="width: 35%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="handleChange" />
              </a-input-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="6" style="float: right; text-align: right">
            <a-button type="primary" @click="getTaskList">查询</a-button>
            <a-button :style="{ margin: '0 8px' }" @click="onReset">重置</a-button>
            <a class="ant-dropdown-link" @click="expand = !expand">{{ expand ? '收起' : '展开' }} <a-icon :type="expand ? 'up' : 'down'" /> </a>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>

    <a-card title="任务列表" size="small" class="filter-data">
      <span slot="extra">
        <task-view ref="view" @setFilter="setFilter" />
        <a-button v-if="false" v-has="{ code: 'project:task:add', project: projectId }" class="handle-menu" type="link" icon="plus" @click="onAdd">添加任务</a-button>
      </span>
      <a-table :scroll="{ x: 1200 }" :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="id" :loading="loading" @change="handleTableChange">
        <span slot="taskId" slot-scope="text, record" style="cursor: pointer" @click="onCopy(`TS-${record.id}`)">
          <div v-if="record.manual_delivery_alone == 1" class="corner_manual" />
          <div v-if="record.delivery_alone == 1" class="corner" />
          <span>{{ `TS-${record.id}` }}</span>
        </span>

        <span slot="status" slot-scope="text, record">
          <task-status-edit :task-id="record.id" :next-status="record.next_status" :status="record.status" @change="getTaskList" />
        </span>
        <span slot="story" slot-scope="text, record">
          <a-tooltip v-if="record.requirement" placement="top" :title="record.requirement.name">
            <a class="story_title" :href="link(record)" target="_blank">{{ record.requirement.name }}</a>
          </a-tooltip>
          <span v-else>--</span>
        </span>
        <span slot="priority" slot-scope="text, record">
          <task-priority-edit :value="record.priority" :task-id="record.id" @change="getTaskList" />
        </span>
        <span slot="point" slot-scope="text, record">
          <task-point-edit :value="record.point" :task-id="record.id" @change="getTaskList" />
        </span>
        <span slot="taskName" slot-scope="text, record">
          <task-name-edit :name="record.name" :task-id="record.id" :project_id="record.project.id" @change="getTaskList" />
        </span>
        <span slot="preStartTime" slot-scope="text, record">
          <task-date-edit :data-source="record" item-name="pre_start_time" @change="getTaskList" />
        </span>
        <span slot="objective" slot-scope="text, record">
          <a-tag v-if="record.objective && record.objective.length > 0" :color="record.objective[0].color">{{ record.objective[0].name }}</a-tag>
        </span>
        <span slot="preEndTime" slot-scope="text, record">
          <task-date-edit :data-source="record" item-name="pre_end_time" @change="getTaskList" />
        </span>
        <span slot="creator" slot-scope="text, record">{{ record.creator.nickname }} </span>
        <span slot="handlers" slot-scope="text, record">
          <task-user-edit :value="record.handlers" :source-id="record.id" />
        </span>
        <span slot="progress" slot-scope="text, record">
          <a-tooltip :title="`已完成: ${count(record, 3)} / 进行中: ${count(record, 2)} / 未开始: ${count(record, 1)}`">
            <a-progress :success-percent="progress(record, 3)" :percent="progress(record, 3) + progress(record, 2)" :show-info="false" />
          </a-tooltip>
        </span>
        <span slot="tag" slot-scope="text, record">
          <a-popover placement="topLeft">
            <template slot="content">
              <a-tag v-for="(tag, index) in filteredTags(record.tags)" :key="index" :color="tag.color">{{ tag.name }}</a-tag>
            </template>
            <template slot="title">
              <span>标签</span>
            </template>
            <a-tag v-for="(tag, index) in filteredTags(record.tags)" :key="index" :color="tag.color">{{ tag.name }}</a-tag>
          </a-popover>
        </span>
        <span v-if="false" slot="action" slot-scope="text, record">
          <a-dropdown placement="bottomCenter">
            <a-icon type="more" />
            <a-menu slot="overlay">
              <a-menu-item>
                <a class="ant-dropdown-link" @click="onEdit(record)"><a-icon type="edit" /> 编辑</a>
              </a-menu-item>
              <a-menu-item>
                <task-version-edit :data-source="record" @reload="getTaskList" />
              </a-menu-item>
              <a-menu-item v-if="false">
                <a v-if="record.delivery_alone == 1" class="ant-dropdown-link" @click="onSetDeliveryStatus(record.id, 0)"><a-icon type="close-circle" /> 取消独立任务</a>
                <a v-else class="ant-dropdown-link" @click="onSetDeliveryStatus(record.id, 1)"><a-icon type="check-circle" /> 标为独立任务</a>
              </a-menu-item>
              <a-menu-item v-if="record.codingTask == 1">
                <a class="ant-dropdown-link" @click="onCreateWorkflow(record)"><a-icon type="bell" /> 提审</a>
              </a-menu-item>
              <a-menu-item>
                <a class="ant-dropdown-link" @click="onDelete(record)"><a-icon type="delete" /> 删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </a-card>
    <task-edit ref="taskEditRef" @close="close" />
    <task-delete-confirm ref="taskDeleteRef" @ok="handleChange" />
  </div>
</template>
<script>
import { onCopy } from '@/utils/utils';
import { tagList } from '@/api/system/tag';
import { storySearch } from '@/api/project/story';
import { projectList } from '@/api/project/project';
import { workflowFastCreate } from '@/api/project/workflow';
import { taskList, taskDeliveryAloneModify } from '@/api/project/task';
import { taskStatus, taskPrioritys, taskFields } from '@/utils/dictionary';

import UserSelect from '@/components/User/UserSelect';
import TaskView from '@/pages/project/task/components/TaskView';
import TaskEdit from '@/pages/project/task/components/TaskEdit';
import TaskDateEdit from '@/pages/project/task/components/TaskDateEdit';
import TaskNameEdit from '@/pages/project/task/components/TaskNameEdit';
import TaskUserEdit from '@/pages/project/task/components/TaskUserEdit';
import TaskPointEdit from '@/pages/project/task/components/TaskPointEdit';
import TaskStatusEdit from '@/pages/project/task/components/TaskStatusEdit';
import TaskPriorityEdit from '@/pages/project/task/components/TaskPriorityEdit';
import TaskDeleteConfirm from '@/pages/project/task/components/TaskDeleteConfirm';

const columns = [
  {
    key: 'action',
    align: 'center',
    width: 20,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 94,
    scopedSlots: { customRender: 'taskId' }
  },
  {
    title: '任务名称',
    dataIndex: 'name',
    key: 'name',
    width: 480,
    scopedSlots: { customRender: 'taskName' }
  },
  {
    title: '所属需求',
    width: 300,
    ellipsis: true,
    scopedSlots: { customRender: 'story' }
  },
  {
    title: '所属项目',
    width: 200,
    dataIndex: 'project.name',
    key: 'project.name'
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: 124,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '标签',
    dataIndex: 'tag',
    key: 'tag',
    width: 100,
    scopedSlots: { customRender: 'tag' }
  },
  {
    title: '处理人',
    dataIndex: 'handlers',
    key: 'handlers',
    width: 130,
    ellipsis: true,
    scopedSlots: { customRender: 'handlers' }
  },
  {
    title: '优先级',
    align: 'center',
    dataIndex: 'priority',
    width: 80,
    sorter: true,
    scopedSlots: { customRender: 'priority' }
  },
  {
    title: '任务类型',
    align: 'center',
    dataIndex: 'objective',
    width: 100,
    scopedSlots: { customRender: 'objective' }
  },
  {
    title: '任务点',
    dataIndex: 'point',
    key: 'point',
    width: 100,
    scopedSlots: { customRender: 'point' }
  },
  {
    title: '计划开始时间',
    dataIndex: 'pre_start_time',
    key: 'pre_start_time',
    align: 'center',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'preStartTime' }
  },
  {
    title: '计划结束时间',
    dataIndex: 'pre_end_time',
    key: 'pre_end_time',
    align: 'center',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'preEndTime' }
  },
  {
    title: '完成时间',
    dataIndex: 'completed_time',
    key: 'completed_time',
    align: 'center',
    sorter: true,
    width: 180
  },
  {
    title: '创建人',
    align: 'center',
    width: 90,
    ellipsis: true,
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_time',
    key: 'created_time',
    align: 'center',
    width: 180
  },
  {
    title: '更新时间',
    dataIndex: 'updated_time',
    key: 'updated_time',
    align: 'center',
    width: 180
  }
];
export default {
  components: { UserSelect, TaskEdit, TaskStatusEdit, TaskDateEdit, TaskPointEdit, TaskNameEdit, TaskUserEdit, TaskPriorityEdit, TaskView, TaskDeleteConfirm },
  data() {
    return {
      columns,
      columnsCopy: JSON.parse(JSON.stringify(columns)),
      taskFields,
      taskStatus,
      taskPrioritys,
      expand: true,
      tagCounts: {},
      loading: false,
      tableData: [],
      objectiveData: [
        { key: 1, value: 1, disabled: true, title: '编码任务', children: [] },
        { key: 2, disabled: true, value: 2, title: '非编码任务', children: [] }
      ],
      tagData: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      filterForm: {
        about: 'all',
        sort_field: null,
        sort: null,
        start_time: null,
        end_time: null,
        time_filter_key: 'pre_time',
        page_size: 20,
        page_number: 1
      },
      versionData: [],
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 20, // 每页中显示20条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      detailVisible: false,
      taskData: {},
      taskId: null,
      requirementValue: [],
      storySearching: false,
      searchStoryData: []
    };
  },

  computed: {
    handlers() {
      return record => {
        return record.handlers ? record.handlers.filter(item => item.role === 3) : null;
      };
    },
    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:project:story:detail',
          params: { project_id: record.project.id },
          query: { storyId: record.requirement.id }
        }).href;
      };
    }
  },

  created() {
    this.getTagList();
    this.getObjectiveList();
  },
  methods: {
    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },
    filteredTags(tags) {
      const uniqueTags = tags.filter((tag, index) => {
        return tags.findIndex(t => t.id === tag.id) === index;
      });

      const tagCounts = tags.reduce((counts, tag) => {
        counts[tag.id] = (counts[tag.id] || 0) + 1;
        return counts;
      }, {});

      return uniqueTags.map(tag => {
        const count = tagCounts[tag.id];
        const processedTag = { ...tag }; // 创建一个新对象来保存处理后的标签
        if (count > 1) {
          processedTag.name = processedTag.name + count + '次';
        }
        return processedTag;
      });
    },
    onCopy,
    // 获取任务列表
    getTaskList() {
      this.loading = true;
      taskList({ ...this.filterForm, type: 'all_dev' })
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getVersionData() {
      projectList({ page_index: 1, page_size: 100 }).then(res => {
        this.versionData = res.data.projects;
      });
    },
    getTagList() {
      tagList({ group_code: 'task_req_tag' }).then(res => {
        this.tagData = res.data.items;
      });
    },
    getObjectiveList() {
      tagList({ group_code: 'coding_task' }).then(res => {
        const children = res.data.items.map(item => ({
          key: item.id,
          value: item.id,
          title: item.name
        }));
        this.objectiveData[0].children = children;
      });
      tagList({ group_code: 'un_coding_task' }).then(res => {
        const children = res.data.items.map(item => ({
          key: item.id,
          value: item.id,
          title: item.name
        }));
        this.objectiveData[1].children = children;
      });
    },

    // 需求搜索
    searchStory(value) {
      storySearch({ project_id: this.projectId, value: value }).then(res => {
        this.searchStoryData = res.data.items;
      });
    },

    handleStoryChange(value) {
      if (value) {
        this.filterForm.requirement_ids = value.map(item => item.key);
      } else {
        this.filterForm.requirement_id = [];
      }
      this.getTaskList();
    },

    onReset() {
      this.filterTime = [];
      this.setFilter({ start_time: null, end_time: null, time_filter_key: 'pre_time' });
      this.requirementValue = [];
      this.$refs['view'].resetView();
    },

    setFilter(filter) {
      this.filterForm = {
        ...filter,
        sort_field: null,
        sort: null,
        page_size: 20,
        page_number: 1
      };
      if (Array.isArray(this.filterForm.fields) && this.filterForm.fields.length > 0) {
        const fields = this.filterForm.fields
          .map(f => {
            return this.taskFields.find(ff => ff.value === f);
          })
          .map(f => f.label);
        this.columns = [
          {
            key: 'action',
            align: 'center',
            width: 20,
            scopedSlots: { customRender: 'action' }
          }
        ];
        fields.forEach(f => {
          if (f === 'TaskPoint') {
            this.columns.push({
              title: '任务点',
              dataIndex: 'point',
              key: 'point',
              width: 100,
              scopedSlots: { customRender: 'point' }
            });
          } else {
            for (let i = 0; i < this.columnsCopy.length; i++) {
              if (this.columnsCopy[i].title === f) {
                this.columns.push(this.columnsCopy[i]);
              }
            }
          }
        });
      } else {
        this.columns = this.columnsCopy;
      }
      if (!this.filterForm.time_filter_key) {
        this.filterForm.time_filter_key = 'pre_time';
      }
      this.pagination.pageSize = 20;
      this.pagination.current = 1;
      this.getTaskList();
    },

    handleChange() {
      this.filterForm.page_number = 1;
      this.pagination.current = 1;
      this.getTaskList();
    },

    handleTableChange(pagination, _, sorter) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.filterForm.sort_field = sorter.field;
      this.filterForm.sort = sorter.order === 'ascend' ? 'asc' : 'desc';
      this.getTaskList();
    },

    /**
     * 点击添加任务
     */
    onAdd() {
      this.$nextTick(() => {
        this.$refs['taskEditRef'].onOpen(null, {});
      });
    },
    onDetail(record) {
      this.taskData = record;
      this.detailVisible = true;
    },

    /**
     * 点击编辑
     */
    onEdit(record) {
      this.$nextTick(() => {
        this.$refs['taskEditRef'].onOpen(record.id, record);
      });
    },
    onSetDeliveryStatus(taskId, status) {
      taskDeliveryAloneModify({ project_id: this.projectId, task_id: taskId, status: status }).then(() => {
        this.$message.success('更新独立任务成功');
        this.getTaskList();
      });
    },
    onCreateWorkflow(record) {
      const self = this;
      record.template_id = 13;
      record.type = 'task';
      workflowFastCreate({ record }).then(res => {
        if (res.data.message === 'success') {
          self.$message.success('创建成功,正在跳转流程详情页～');
          this.$router.push({
            name: 'page:project:workflow:detail',
            query: { workflowId: res.data.workflow_id }
          });
        } else {
          if (res.data.message) {
            self.$message.warning(res.data.message);
          }
        }
      });
    },
    onDelete(record) {
      this.$nextTick(() => {
        this.$refs.taskDeleteRef.onOpen(record.id, this.projectId);
      });
    },

    close(type = 'submit') {
      this.taskId = null;
      this.taskData = {};
      this.editVisible = false;
      this.detailVisible = false;
      if (type === 'submit') {
        this.getTaskList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 8px;
  display: flex;

  .ant-form-item-control-wrapper {
    flex: 1;
    width: 71%;
  }
}

.filter-data {
  margin-top: 16px;
}

.story_title {
  color: rgba(0, 0, 0, 0.65);
}

.story_title:hover {
  cursor: pointer;
  color: #1890ff;
}

.corner {
  position: relative;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
}
.corner_manual {
  position: relative;
  background: linear-gradient(135deg, rgba(30, 216, 58, 0.4), transparent) #37ec3a;
}

.corner::before {
  position: absolute;
  top: -12px;
  left: -8px;
  font-size: 12px;
  height: 16px;
  content: '独立交付';
  border-radius: 2px 2px 2px 0px;
  padding: 2px 4px;
  line-height: 12px;
  color: #fff;
  background: linear-gradient(135deg, rgba(76, 191, 85, 0.627), transparent) #62b25b;
  background-blend-mode: soft-light;
}
.corner_manual::before {
  position: absolute;
  bottom: -4px;
  left: -8px;
  font-size: 12px;
  height: 16px;
  content: '独立交付';
  border-radius: 2px 2px 2px 0px;
  padding: 2px 4px;
  line-height: 12px;
  color: #fff;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
  background-blend-mode: soft-light;
}
</style>
